export const siteInfo = {
  name: '第一学术福利导航网',
  description: '第一学术福利导航网是专为科研人员、高校师生打造的学术资源导航平台，汇聚免费论文数据库、文献下载工具、学术期刊、科研福利资源，帮助用户快速找到高质量学术资料，节省科研时间，提升学术效率。',
  keywords: '第一学术福利导航网,学术资源免费导航,免费论文下载网站,学术福利资源汇总,科研文献导航平台,学术数据库推荐,免费学术工具导航',
  url: 'https://www.xueshudaohang.cn',
  foundingYear: '2020',
  email: 'contact@xueshudaohang.cn',
  address: '北京市海淀区中关村南大街5号院',
  phone: '010-88886666',
  stats: {
    resources: '500+',
    users: '100000+',
    categories: '12',
    articles: '2000+',
  },
};

export const breadcrumbHome = { label: '首页', path: '/' };

export const footerLinks = {
  categories: [
    { label: '免费论文数据库', path: '/category/free-paper-db' },
    { label: '文献下载工具', path: '/category/download-tools' },
    { label: '学术期刊导航', path: '/category/journals' },
    { label: '科研福利资源', path: '/category/research-benefits' },
    { label: '开源学术平台', path: '/category/open-access' },
    { label: '学术写作辅助', path: '/category/writing-tools' },
  ],
  about: [
    { label: '关于我们', path: '/about' },
    { label: '品牌介绍', path: '/about#brand' },
    { label: '联系我们', path: '/about#contact' },
  ],
  help: [
    { label: '使用指南', path: '/article/usage-guide' },
    { label: '常见问题', path: '/article/faq' },
    { label: '资源提交', path: '/about#contact' },
  ],
};

export const navLinks = [
  { label: '首页', path: '/' },
  { label: '论文数据库', path: '/category/free-paper-db' },
  { label: '文献工具', path: '/category/download-tools' },
  { label: '学术期刊', path: '/category/journals' },
  { label: '科研福利', path: '/category/research-benefits' },
  { label: '开源平台', path: '/category/open-access' },
  { label: '写作辅助', path: '/category/writing-tools' },
  { label: '关于我们', path: '/about' },
];